<template>
    <img
        v-once
        :class="classes"
        :src="src"
        :width="width"
        :height="height"
        :alt="alt" />
</template>

<script>
import { isFrench } from '@whisper/utils/lang';

export default {
  props: {
    classes: {
      required: false,
      default: '',
    },
    width: {
      type: String,
      required: false,
      default: 'auto',
    },
    height: {
      type: String,
      required: false,
      default: 'auto',
    },
  },
  computed: {
    src() {
      return '/img/svg/the_image_salon_gold_fr.svg';
    },
    alt() {
      return isFrench() ? 'Salon Image' : 'Image Salon';
    },
  },
};
</script>

<style>

</style>
